import React from 'react';
import Layout from '../layout';
import BookDemoSectionOne from '../components/Esper/BookDemo/BookDemoSectionOne';
import messages from '../i18n/en';

export default (props: any) => (
  <Layout
    messages={messages}
    title={'See Esper In Action. Book a Demo Today.'}
    description={`Request a demo of Esper's platform for Android DevOps. Esper's cloud and APIs are powerful MDM features for the IoT -era of enterprise mobility management. `}
    keywords={`Esper Free Trial, Free MDM Software, Android DevOps tools`}
    className="first-page"
    location={props.location}
  >
    <BookDemoSectionOne messages={messages} />
  </Layout>
);
